import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { getOperatingPointsTdh, getProducedDataSetsTdh } from "@/libs/charting";
import type { TaperedPumpChartData } from ".";
import type { XrefPump } from "@/composables/forms/formTypes";
import { getRorDataSets } from "../_common/getRorDataSets";
import { buildTaperedPumpChartContext } from "../_common/getContext";
import type { ConvertableUnit } from "@/libs/units";

export const useTaperedPumpTornadoChartingData = (
  minFrequency: number,
  maxFrequency: number,
  scenarioCalculations: ScenarioCalculations,
  targetLiquidFlowUnit: ConvertableUnit,
  targetPowerUnit: ConvertableUnit,
  targetLargeLengthUnit: ConvertableUnit,
  targetPressureUnit: ConvertableUnit,
  pump: XrefPump,
  useEvaluationOverrides?: boolean
): TaperedPumpChartData | undefined => {
  const context = buildTaperedPumpChartContext(
    minFrequency,
    maxFrequency,
    pump,
    scenarioCalculations,
    targetLiquidFlowUnit,
    targetLargeLengthUnit,
    targetPressureUnit,
    targetPowerUnit,
    useEvaluationOverrides
  );

  if (!context) {
    return undefined;
  } else {
    const { targetXUnit, targetTdhYUnit } = context;
    const operatingPointTdhData = getOperatingPointsTdh(context);
    operatingPointTdhData.operatingPoints =
      operatingPointTdhData.operatingPoints.filter(p => p.label !== "Average");
    const rorDataSetsTdh = getRorDataSets(context, "tdh");
    const producedTdhData = getProducedDataSetsTdh(context, undefined, true);
    const producedDataSetsTdh = producedTdhData.map(ds => ds.dataSet);

    return {
      context,
      tdh: {
        operatingPointData: operatingPointTdhData,
        rorDataSets: rorDataSetsTdh,
        operatingDataSets: producedDataSetsTdh,
        targetXUnit,
        targetYUnit: targetTdhYUnit
      }
    };
  }
};
